import { render } from "./DddCover.vue?vue&type=template&id=8e0f9010"
import script from "./DddCover.vue?vue&type=script&lang=js"
export * from "./DddCover.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__